export default {
  mounted() {
    global.EventBus.$on("reload", this.reload);
  },
  beforeDestroy() {
    global.EventBus.$off("reload");
  }
};
